module.exports = __webpack_public_path__ + "ui-static/img/cameras-no-items_light.e3c05dbe.svg";